/**
 * 产品关接口
 */
const PREFIX = "checkmall-goods";
let goodsApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    /**产品列表 */
    goodsList: "/api/goods/list",
    /**产品详情 */
    goodsInfo: "/api/goods/goodsByPrn",
    /**产品检项 */
    itemLimisList: "/api/project/limisList",
    /**院内设备 */
    getYnDetail: "/api/otherEquipment/getYnDetail",
    /**其他设备 */
    othereqList: "/api/otherEquipment/list",
    /**检测依据列表*/
    funStdList: "/api/project/lims/getFunStdList",
    /**查询报告地址*/
    getReportUrl: "/report/searchReportByOrderId",

    /**查询检测数据地址*/
    getReportAnnex: "/report/searchAnnexByOrderId",

    /**院内设备列表*/
    getYNlist: "/api/otherEquipment/list",
    /**查询院内设备详情*/
    getYNdetails: "/api/otherEquipment/getYnDetail",
  },
};
export default goodsApi;
